import '@babel/polyfill';
import 'whatwg-fetch';

import React from 'react';
import { createRoot } from 'react-dom/client';
import classNames from 'classnames';

// Paper
import { AppRoot } from '@nackle/deck';
import { Layout } from 'antd';
const { Content } = Layout;
import { getMiddleware as getRouteMiddleware, routes } from './app-routing.jsx';

// Routing
import { Route, Link, routeHistory } from '@nackle/biw-web-router';

import {
    EzThanksLogo,
    ElevateHomeIcon,
    SlackIcon,
    TeamsIcon,
    OutlookIcon,
    DividerIcon,
    ElevateIcon
} from './components/shared/icons/icons.jsx';

import './styles/style.less';
const EZ_THANKS_TYPE = 'ezthanks';

const INTEGRATIONS = [ {
    type: 'slack',
    title: 'Slack',
    image: <SlackIcon />
}, {
    type: 'teams',
    title: 'Teams',
    image: <TeamsIcon />
}, 
{
    type: 'outlook',
    title: 'Outlook',
    image: <OutlookIcon />
} ];

class App extends React.Component {
    state = {
        activeType: location.pathname.split( '/' )[ 1 ] || 'slack'
    };

    render() {
        const {
            activeType
        } = this.state;
        return (
            <Route render={ ( route ) => (
                <AppRoot>
                    <Layout>
                        <header className="header">
                            <div className="wrapper">
                                { activeType === EZ_THANKS_TYPE
                                    ?
                                    <div className="logoTitleContainer">
                                        <EzThanksLogo />
                                        <span className="title">EZ Thanks</span>
                                    </div>
                                    :
                                    <Link to={ `/${ activeType }` } className="logoTitleContainer"  >
                                        <ElevateHomeIcon />
                                    </Link>
                                }
                                <div className="header-divider">
                                    <DividerIcon />
                                </div>
                                <div className="integrations-block">
                                    <span>Integrations</span>
                                </div>
                            </div>
                        </header>
                        <Content className="main-content">
                            {
                                route.match && route.match.showTabs && (
                                    <div className="tab-container">
                                        {
                                            INTEGRATIONS.map( i => (
                                                <a
                                                    key={ i.type }
                                                    className="tab"
                                                    href={ `#${ i.type }` }
                                                    onClick={ this.handleClick( i.type ) }
                                                >
                                                    <span className="icon">
                                                        { i.image }
                                                    </span>
                                                    <span className="title">{ i.title }</span>
                                                    <span
                                                        className={ classNames(
                                                            'underline', {
                                                                active: activeType === i.type
                                                            } )
                                                        }
                                                    />
                                                </a>
                                            ) )
                                        }
                                    </div>
                                )
                            }
                            {
                                route.match ? (
                                    route.component
                                ) : (
                                    null
                                )
                            }
                        </Content>
                    </Layout>
                    { activeType !== EZ_THANKS_TYPE && (
                        <div className="footer">
                            <div className="wrapper">
                                <div className="left-container">
                                    <ElevateIcon />
                                    <div className="links">
                                        <a href={ 'https://teams.elevate-platform.com/terms' }>
                                                Terms & Conditions
                                        </a>
                                        <a href={ 'https://teams.elevate-platform.com/privacy' }>
                                                Privacy Policy
                                        </a>
                                    </div>
                                </div>
                                <span className="copyright">
                                    { `©${ new Date().getFullYear() } BI Worldwide. All Rights Reserved.` }
                                </span>
                            </div>
                        </div>
                    ) }
                </AppRoot>
            ) } />
        );
    }

    handleClick = ( type ) => ( e ) => {
        e.preventDefault();

        this.setState( { activeType: type }, () => {
            routeHistory.push( `/${ type }` );
        } );
    };
}

routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware() );

const root = createRoot( document.getElementById( 'app-root' ) );
root.render( <App /> );
